"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCanadianAddressCountry = exports.CountryToCodeMapping = exports.LocaleConfig = void 0;
var states_list_1 = require("./states_list");
exports.LocaleConfig = {
    US: {
        states: states_list_1.US_States,
        labels: {
            zip: 'Zip Code',
            state: 'State',
        },
        zipValidationRegex: /^\d{5}$|^\d{5}-\d{4}$/,
        countryName: 'United States',
        code: 'US',
    },
    CA: {
        states: states_list_1.CA_States,
        labels: {
            zip: 'Postal Code',
            state: 'Province',
        },
        zipValidationRegex: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
        countryName: 'Canada',
        code: 'CA',
    },
};
exports.CountryToCodeMapping = {
    'United States': 'US',
    Canada: 'CA',
};
/** @param addressCountry a recharge address's `country` value */
var isCanadianAddressCountry = function (addressCountry) {
    var country = addressCountry.toLowerCase();
    // It's likely that the country is always "Canada" or "United States" but it doesn't hurt to check for "CA" as well
    return country === 'canada' || country === 'ca';
};
exports.isCanadianAddressCountry = isCanadianAddressCountry;
